<template>
  <div class="modal" :class="{ 'is-active': show }" v-if="show">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Location Lookup</p>
      </header>
      <section class="modal-card-body">
        <rolodex-location-list :can-edit-and-delete="false" @selected="notify" />
      </section>
      <footer class="modal-card-foot columns">
        <div class="column is-one-third">
          <button class="button" type="button" @click="close" >Close</button>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>
import RolodexLocationList from '@/components/RolodexLocationList'
export default {
  name: 'RolodexLocationList-Modal',

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  components: {
    RolodexLocationList
  },

  methods: {
    close() {
      this.$emit('update:show', false)
    },

    notify(selection) {
      this.$emit('input', selection)
      this.$emit('selected', selection)
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: 960px;
}
</style>
